const data = [
  {
    id: 1,
    image: "foodWoman.png",
    classname: "w-[8.3rem] h-[16rem]  hidden md:block",
  },
  {
    id: 2,
    image: "apron-man.png",
    classname: "w-[16rem] h-[16rem] hidden md:block",
  },
  {
    id: 3,
    image: "african-dl.png",
    image2: "african-dlBig.png",
    classname: "md:w-[16rem] md:h-[16rem]",
  },
  {
    id: 4,
    image: "african-dl2.png",
    image2: "african-dl2Big.png",
    classname: "md:w-[16rem] md:h-[16rem]",
  },
  {
    id: 5,
    image: "Small-business.png",
    classname: "w-[16rem] h-[16rem] hidden md:block",
  },
  {
    id: 6,
    image: "oldWoman.png",
    classname: "w-[8.3rem] h-[16rem] hidden md:block",
  },
];

export function Header() {
  return (
    <header className="mb-20 ">
      <h1 className=" text-center text-3xl font-semibold mb-12 md:w-[50%] lg:w-[38%] mr-auto ml-auto leading-[48px] md:leading-[60px]">
        Expand Your Business With Our SME Loan Financing With no Collateral.
      </h1>
      <button className=" bg-[#8524D6] font-medium text-white h-[3rem] w-[12rem] mb-8 rounded-md mr-auto ml-auto block">
        Join our waitlist
      </button>
      <div className="thin-scrollbar  grid grid-flow-col justify-between  mr-auto ml-auto w-fit md:w-full gap-x-8 overflow-auto ">
        {data.map((item) => {
          return <ImageContainer {...item} key={item.id} />;
        })}
      </div>
    </header>
  );
}

function ImageContainer(prop) {
  const { image, id, classname, image2 } = prop;

  const largeImageId = [3, 4];

  return (
    <div className={classname}>
      <img
        src={`images/${largeImageId.includes(id) ? image2 : image}`}
        alt={`header${id}`}
        className={"w-full h-full object-cover"}
      />
    </div>
  );
}


{/* <div className=" w-[8.3rem] h-[16rem]  hidden md:block">
          <img
            src="images/foodWoman.png"
            alt="header1"
            className="w-full h-full object-cover "
          />
        </div>
        <div className="w-[16rem] h-[16rem] hidden md:block">
          <img
            src="images/apron-man.png"
            alt="header2"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="md:w-[16rem] md:h-[16rem] ">
          <img
            src="images/african-dl.png"
            alt="header3"
            className="  md:hidden"
          />
          <img
            src="images/african-dlBig.png"
            alt="header3"
            className=" w-full h-full object-cover hidden md:block"
          />
        </div>
        <div className=" md:w-[16rem] md:h-[16rem] ">
          <img
            src="images/african-dl2.png"
            alt="header4"
            className=" md:hidden"
          />
          <img
            src="images/african-dl2Big.png"
            alt="header4"
            className=" w-full h-full object-cover hidden md:block"
          />
        </div>
        <div className="w-[16rem] h-[16rem] hidden md:block">
          <img
            src="images/Small-business.png"
            alt="header5"
            className=" w-full h-full object-cover"
          />
        </div>
        <div className="w-[8.3rem] h-[16rem] hidden md:block">
          <img
            src="images/oldWoman.png"
            alt="header6"
            className=" w-full h-full object-cover"
          />
        </div> */}